import { lazyLoad } from 'app/utils/loadable';

export const AboutPage = lazyLoad(
  () => import('./about-page'),
  (module) => module.AboutPage
);
